export default "__VITE_ASSET__CeLPEmw___"